import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DashedFrame = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  border: `1.5px dashed ${theme.palette.grey[400]}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));
